import React from "react";
import { Col, Row } from "react-bootstrap";
import { formatarData } from "../../../../components/Formatters/DateTime";

const DebitoSuspensoDetalhe = ({ data }) => (
  <div>
    <Row>
      <Col>
        {data?.detalhesDebitosSuspensosPorSituacao?.length > 0 ? (
          <div>
            <table className="table table-striped table-bordered" width="90%">
              <thead>
                <tr>
                  <th>Referência</th>
                  <th>Origem Débito</th>
                  <th>Cobrança</th>
                  <th>Valor (R$)</th>
                  <th>Cod. Rec.</th>
                  <th>DT Geração</th>
                </tr>
              </thead>
              <tbody>
                {data?.detalhesDebitosSuspensosPorSituacao?.map((debitoDetalhado) => (
                  <tr>
                    <td>{formatarData(debitoDetalhado.dataReferencia, "dd/MM/yyyy HH:MM:SS")}</td>
                    <td>{debitoDetalhado.origemDebito}</td>
                    <td>{debitoDetalhado.codigoCobranca}</td>
                    <td className="text-right">
                      {debitoDetalhado.valorDebito.toLocaleString("pt-br", { minimumFractionDigits: 2 })}
                    </td>
                    <td>{debitoDetalhado.codigoReceita}</td>
                    <td>{formatarData(debitoDetalhado.dataGeracao, "dd/MM/yyyy HH:MM:SS")}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <b>Nenhum registro para exibir</b>
        )}
        ;
      </Col>
    </Row>
  </div>
);

export default DebitoSuspensoDetalhe;
